import type { ReactNode } from "react";
import { SweepButton, SweepLabel } from "@softmax/design-system";
import { profileImageTypes } from "../profile-image";
import type { ProfileNotice } from "../profile-notice";
import { circleStyle } from "./profile-styles";
import { ProfileStatus } from "./profile-status";

export function ProfilePicture({
  inputId,
  src,
  initial,
  changeLabel,
  removeLabel,
  disabled,
  disabledTitle,
  busy,
  onPick,
  onRemove,
  trailing,
  status,
}: {
  inputId: string;
  src: string | null;
  initial: string;
  changeLabel: string;
  removeLabel: string;
  disabled: boolean;
  disabledTitle?: string;
  busy: boolean;
  onPick: (file: File) => void;
  onRemove: () => void;
  trailing?: ReactNode;
  status: ProfileNotice;
}) {
  const inert = disabled || busy;
  return (
    <div className="flex items-center gap-[16px]">
      <div className={circleStyle} aria-hidden="true">
        {src ? (
          <img src={src} alt="" className="size-full object-cover" />
        ) : (
          initial
        )}
      </div>
      <div className="flex flex-wrap items-center gap-[8px]">
        <SweepLabel
          quiet
          htmlFor={inputId}
          focus="ring"
          aria-disabled={inert || undefined}
          title={disabled ? disabledTitle : undefined}
        >
          {changeLabel}
          <input
            id={inputId}
            type="file"
            accept={profileImageTypes}
            className="sr-only"
            disabled={inert}
            onChange={(event) => {
              const picked = event.target.files?.[0];
              event.target.value = "";

              if (picked) onPick(picked);
            }}
          />
        </SweepLabel>
        <SweepButton
          quiet
          type="button"
          focus="ring"
          disabled={inert || src === null}
          title={disabled ? disabledTitle : undefined}
          onClick={onRemove}
        >
          {removeLabel}
        </SweepButton>
        {trailing}
        <ProfileStatus notice={status} />
      </div>
    </div>
  );
}
